import { FormControlLabel, Checkbox, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { useFormContext, useController } from "react-hook-form";
import PropTypes from "prop-types";

CheckboxInput.propTypes = {
    fieldAttributes: PropTypes.object,
    fieldName: PropTypes.string,
}

export default function CheckboxInput({ fieldAttributes, fieldName }) {
    const { control } = useFormContext();
    const { field } = useController({ name: fieldName, control });
    const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);

    return (
        <FormControlLabel
            control={
                <Checkbox
                    sx={{
                        ml: '5px', p: '4px',
                        '& .MuiSvgIcon-root': { fontSize: 14, }
                    }}
                    size='small'
                    disabled={!fieldAttributes.isEditable || isCanceled}
                    checked={!!field?.value}
                    onChange={(value) => field.onChange(value)}
                />
            }

            label={
                <Typography variant="caption" color="text.secondary">
                    {fieldAttributes.label}
                </Typography>
            }
        />
    );
}